/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_DownloadInputs */

const en_fc_dl_download = /** @type {(inputs: Fc_Dl_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Fc_Dl_DownloadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_download = /** @type {((inputs?: Fc_Dl_DownloadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_DownloadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_download(inputs)
});
export { fc_dl_download as "fc.dl.download" }